import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import api from '@/api/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { toast } from 'sonner';

export default function DriverForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({ first_name: '', last_name: '', email_contact: '', phone: '', nif: '', iban: '' });

  useEffect(() => {
    if (id) {
      api.get(`/drivers/${id}`).then(({ data }) => {
        if (data.success) setForm(data.data);
      }).catch(() => toast.error('Erro ao carregar motorista'));
    }
  }, [id]);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = id
        ? await api.put(`/drivers/${id}`, form)
        : await api.post('/drivers', form);
      if (res.data.success) {
        toast.success(id ? 'Motorista atualizado' : 'Motorista criado');
        navigate('/drivers');
      } else throw new Error(res.data.error);
    } catch (err) {
      toast.error(err.message || 'Erro ao guardar');
    }
  };

  return (
    <div className="max-w-xl space-y-4">
      <h1 className="text-3xl font-bold tracking-tight">{id ? 'Editar Motorista' : 'Novo Motorista'}</h1>
      <Card>
        <CardHeader>
          <CardTitle>Dados cadastrais</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-2"><label className="text-sm font-medium">Nome</label><Input name="first_name" value={form.first_name} onChange={handleChange} required /></div>
              <div className="space-y-2"><label className="text-sm font-medium">Apelido</label><Input name="last_name" value={form.last_name} onChange={handleChange} required /></div>
            </div>
            <div className="space-y-2"><label className="text-sm font-medium">Email</label><Input type="email" name="email_contact" value={form.email_contact} onChange={handleChange} /></div>
            <div className="space-y-2"><label className="text-sm font-medium">Telemóvel</label><Input name="phone" value={form.phone} onChange={handleChange} /></div>
            <div className="space-y-2"><label className="text-sm font-medium">NIF</label><Input name="nif" value={form.nif} onChange={handleChange} /></div>
            <div className="space-y-2"><label className="text-sm font-medium">IBAN</label><Input name="iban" value={form.iban} onChange={handleChange} /></div>
            <div className="flex gap-2">
              <Button type="submit">Guardar</Button>
              <Button type="button" variant="outline" onClick={() => navigate('/drivers')}>Cancelar</Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
